import { Injectable } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TextShowMoreLessService {
  showButtonType = true;
  textTrimResult: any;
  textDefaultResult: any;
  readMoreLess: any[] = [];
  readMoreClicked = false;

  constructor(private translation: TranslationService) {}

  readMoreLessTranslator() {
    // DO NOT CHANGE THE ORDER

    const readMoreLessTranslation = ['readMore', 'readLess'];

    readMoreLessTranslation.forEach((translate) => {
      this.translation
        .translate(`product.productOptions.${translate}`)
        .pipe(take(1))
        .subscribe((text) => {
          if (this.readMoreLess.length == 2) {
            this.readMoreLess = [];
          }
          this.readMoreLess.push(text);
        });
    });
  }
  readMoreIsClicked(buttonClicked: boolean) {
    this.readMoreClicked = buttonClicked;
  }

  textTrim = (paragraphs: any, paragraphLimit: number = 500) => {
    let button = false;
    if (paragraphs.length > paragraphLimit) {
      if (this.showButtonType && !this.readMoreClicked) {
        // First Load
        this.textTrimResult = `${paragraphs.substring(0, paragraphLimit)}...`;
      } else if (this.readMoreClicked) {
        this.textDefaultResult = paragraphs;
        this.showButtonType = false;
      } else if (!this.showButtonType && !this.readMoreClicked) {
        this.textTrimResult = `${paragraphs.substring(0, paragraphLimit)}...`;
        this.showButtonType = true;
      }
      button = true;
    } else {
      this.textDefaultResult = paragraphs;
      button = false;
      this.showButtonType = false;
    }
    return {
      message: this.showButtonType ? this.textTrimResult : this.textDefaultResult,
      paragraphLimit,
      showButton: button,
      showButtonMessage: this.showButtonType ? this.readMoreLess[0] : this.readMoreLess[1],
    };
  };
}
